import { FinancialActivityResponse } from '@/types/service-response'

export class ProjectFinancialActivities {
  public constructor (
    readonly zeile: number,
    readonly soll: string,
    readonly haben: string,
    readonly betrag: number | null,
    readonly waehrung: string,
    readonly steuercode: string,
    readonly steuerbetrag:  number | null,
    readonly kostenstelle: string,
    readonly kostentraeger: string,
    readonly text: string
  ) {}

  static createFromResponse (responseData: FinancialActivityResponse[]): Array<ProjectFinancialActivities> {
    let result: Array<ProjectFinancialActivities> = []
    if (responseData) {
      result = responseData.map((item: FinancialActivityResponse ) => {
        return new ProjectFinancialActivities(
          item.Zeile,
          item.Soll ? item.Soll : '',
          item.Haben ? item.Haben : '',
          item.Betrag !== null ? parseFloat(parseFloat(item.Betrag).toFixed(2)) : null,
          item.Waehrung ? item.Waehrung : '',
          item.Steuercode ? item.Steuercode : '',
          item.Steuerbetrag !== null ? parseFloat(parseFloat(item.Steuerbetrag).toFixed(2)) : null,
          item.Kostenstelle ? item.Kostenstelle : '',
          item.Kostentraeger ? item.Kostentraeger : '',
          item.Text ? item.Text : ''
        )
      })
    }
    return result
  }
}
